export const edyStatisticsTranslations = {
  lv: {
    title: 'Platformas statistika',
    tabs: {
      label: 'Statistikas sadaļas',
      users: 'Lietotāji',
      interns: 'Praktikanti un prakses',
      organizations: 'Organizācijas',
      supportCases: 'Atbalsta gadījumi',
    },
    views: {
      daily: 'Pa dienām',
      monthly: 'Pa mēnešiem',
      hourly: 'Pa stundām',
    },
    month: 'Mēnesis',
    year: 'Gads',
    date: 'Datums',
    today: 'Šodien',
    serverTime: 'Servera laiks: {{time}} UTC',
    charts: {
      users: 'Lietotāji',
      internshipsAndInterns: 'Prakses un praktikanti',
      interns: 'Praktikanti',
      organizations: 'Organizācijas',
      supportCases: 'Uzsāktie atbalsta gadījumi',
      supportUsers: 'Lietotāji, kas uzsāka atbalsta gadījumus',
    },
    series: {
      totalUsers: 'Lietotāji kopā',
      activeUsers24: 'Aktīvie lietotāji (24 h)',
      activeUsers: 'Aktīvie lietotāji',
      activeUsers1h: 'Aktīvie lietotāji (1 h)',
      activeInterns: 'Aktīvie praktikanti',
      activeInternships: 'Aktīvās prakses',
      totalInterns: 'Praktikanti kopā',
      totalOrgs: 'Organizācijas kopā',
      activeOrgs: 'Aktīvās organizācijas',
      diaryRecordCount: 'Dienasgrāmatas ieraksti (24 h)',
      diaryRecords1h: 'Dienasgrāmatas ieraksti (1 h)',
      supportCases: 'Atbalsta gadījumi',
      supportUsers: 'Lietotāji',
    },
  },
  en: {
    title: 'Platform statistics',
    tabs: {
      label: 'Statistics sections',
      users: 'Users',
      interns: 'Interns and internships',
      organizations: 'Organizations',
      supportCases: 'Support cases',
    },
    views: {
      daily: 'Daily',
      monthly: 'Monthly',
      hourly: 'Hourly',
    },
    month: 'Month',
    year: 'Year',
    date: 'Date',
    today: 'Today',
    serverTime: 'Server time: {{time}} UTC',
    charts: {
      users: 'Users',
      internshipsAndInterns: 'Internships and interns',
      interns: 'Interns',
      organizations: 'Organizations',
      supportCases: 'Support cases started',
      supportUsers: 'Users who started support cases',
    },
    series: {
      totalUsers: 'Total users',
      activeUsers24: 'Active users (24 h)',
      activeUsers: 'Active users',
      activeUsers1h: 'Active users (1 h)',
      activeInterns: 'Active interns',
      activeInternships: 'Active internships',
      totalInterns: 'Total interns',
      totalOrgs: 'Total organizations',
      activeOrgs: 'Active organizations',
      diaryRecordCount: 'Diary records (24 h)',
      diaryRecords1h: 'Diary records (1 h)',
      supportCases: 'Support cases',
      supportUsers: 'Users',
    },
  },
}
